import { atom } from 'jotai'

import type { IdentifyingInformation } from '@app/domains/layers/types/layers.types'

export type SelectedIdentifyingInformation = {
  [assetType: string]: {
    [hazardScenario: string]: IdentifyingInformation | undefined
  }
}

export const selectedIdentifyingInformationAtom = atom<SelectedIdentifyingInformation>({})
